import { ComponentChildren } from 'preact';

import { useState, useLayoutEffect } from 'preact/hooks';

import { PageSkeleton } from '@paylink/components/composed';
import { ApiService, initEventManager } from '@paylink/services';
import { TokenManager } from '@paylink/services/TokenManager.service';
import { generateBrowserFingerprint } from '@paylink/utils';

interface IAppInitProps {
	children: ComponentChildren;
}

export const AppInit = ({ children }: IAppInitProps) => {
	const [isReady, setIsReady] = useState(false);

	useLayoutEffect(() => {
		const init = async () => {
			try {
				initEventManager();
				await generateBrowserFingerprint();
				await TokenManager.init();
				ApiService.init();

				setIsReady(true);
			} catch (err) {
				console.error('Initialization failed', err);
			}
		};
		init();
	}, []);

	if (!isReady) return <PageSkeleton />;

	return <>{children}</>;
};
